var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col_group" },
    [
      _vm._l(_vm.column, function(category, categoryIdx) {
        return !_vm.isEmpty(category)
          ? [
              _c(
                "a",
                {
                  key: category.productUiId,
                  staticClass: "service_title",
                  class: { collapsed: !category.showCollapse },
                  attrs: {
                    "aria-controls":
                      "service_menu_collapse_" + category.productUiId,
                    "aria-expanded": category.showCollapse ? "true" : "false",
                    "data-toggle": "collapse"
                  },
                  on: {
                    click: function($event) {
                      _vm.toggleCollapse(category)
                    }
                  }
                },
                [_vm._v(_vm._s(category.name))]
              ),
              _vm._v(" "),
              _c(
                _vm.isMobile ? "b-collapse" : "ul",
                {
                  key: categoryIdx,
                  tag: "component",
                  staticClass: "lst_service_menu",
                  attrs: {
                    tag: "ul",
                    id: "service_menu_collapse_" + category.productUiId
                  },
                  model: {
                    value: category.showCollapse,
                    callback: function($$v) {
                      _vm.$set(category, "showCollapse", $$v)
                    },
                    expression: "category.showCollapse"
                  }
                },
                _vm._l(category.services, function(service) {
                  return _c(
                    "li",
                    {
                      key: service.productUiId,
                      staticClass: "service_menu",
                      class: _vm.getServiceMenuClass(service)
                    },
                    [
                      _vm.mode == "homepage"
                        ? _c(
                            "router-link-ex",
                            {
                              staticClass: "link_txt",
                              attrs: {
                                to:
                                  "" +
                                  _vm.marketPlaceBasePath +
                                  _vm.parseServiceName(category.name) +
                                  "/" +
                                  _vm.parseServiceName(service.name)
                              },
                              nativeOn: {
                                click: function($event) {
                                  _vm.close()
                                }
                              }
                            },
                            [
                              _vm.isMobile
                                ? _c("span", { staticClass: "service_txt" }, [
                                    _vm._v(_vm._s(service.name))
                                  ])
                                : _vm._e(),
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.isMobile ? "" : service.name) +
                                  "\n          "
                              ),
                              _vm.showGnbBadges(
                                _vm.getServiceMenuClass(service)
                              )
                                ? _c("span", { staticClass: "service_badge" })
                                : _vm._e()
                            ]
                          )
                        : _c(
                            "a",
                            {
                              staticClass: "link_txt",
                              attrs: {
                                href:
                                  "" +
                                  _vm.getDomain("homepage") +
                                  _vm.marketPlaceBasePath +
                                  _vm.parseServiceName(category.name) +
                                  "/" +
                                  _vm.parseServiceName(service.name)
                              }
                            },
                            [
                              _vm._v(_vm._s(service.name)),
                              _vm.showGnbBadges(
                                _vm.getServiceMenuClass(service)
                              )
                                ? _c("span", { staticClass: "service_badge" })
                                : _vm._e()
                            ]
                          )
                    ],
                    1
                  )
                })
              )
            ]
          : _vm._e()
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }